// STYLES
import '../../assets/styles/loading.css';

export default function Loading(props) {
    if (props.inline) {
        return (
            <div className="loading-inline-container">
                (<div className="loading-spinnerInline"></div>)
            </div>
        );
    }

    return (
        <>
            {props.isLogin ? (
                <div className="loading-containerLogin">
                    <div className="loading-spinnerLogin"></div>
                </div>
            ) : (
                <div className="loading-container">
                    <div className="loading-spinner"></div>
                </div>
            )}
        </>
    );
}
